import { Content } from "antd/es/layout/layout";
import PaymentsOutlet from "./PaymentsOutlet";
import { Layout } from "antd";

export default function Payments() {
  return (
    <Layout className="layout-card">
      <Content className="layout-card-content">
        <PaymentsOutlet />
      </Content>
    </Layout>
  );
}
